import PropTypes from "prop-types";
import React, { memo } from "react";
import { CloseDialogIcon } from "../../static/icons/CloseDialogIcon";
import styles from "./ModalBottom.module.scss";

ModalBottom.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  // TODO: what is this?
  isSub: PropTypes.bool,
};

function ModalBottom({
  children,
  isOpen,
  isSub = false,
  noVerticalPadding = false,
  noPadding = false,
  onClose,
  header,
  footer,
}) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className={styles.modalOverlay} onClick={onClose} role="dialog" aria-modal="true">
      <div className={`${styles.modalWindow} ${isSub ? styles.subModal : ""} ${noVerticalPadding ? styles.noVerticalPadding : ""} ${noPadding ? styles.noPadding : ""}`} onClick={(e) => e.stopPropagation()}>
         
        {header && <div className={styles.header}>{header}</div>}
        <div className={styles.content}>{children}</div>
        {footer && (
          <div className={styles.footer}>
            <span className={styles.note}>Powered by</span>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}

export default memo(ModalBottom);
